import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class DistributionCenter implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fName: string,
    private fCode: string,
    private fEmail: string,
    private fIsActive: boolean,
    private fIsBoxParametersRequired: boolean,
    private fSendNotificationCopy: boolean,
    private fSerialNumber?: number
  ) {
    [
      fId,
      fName,
      fCode,
      fEmail,
      fIsActive,
      fIsBoxParametersRequired,
      fSendNotificationCopy,
    ].forEach((arg, index) => {
      if (arg === undefined || arg === null) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get name(): string {
    return this.fName;
  }

  get code(): string {
    return this.fCode;
  }

  get email(): string {
    return this.fEmail;
  }

  get isActive(): boolean {
    return this.fIsActive;
  }

  get isBoxParametersRequired(): boolean {
    return this.fIsBoxParametersRequired;
  }

  get shouldSendNotificationCopy(): boolean {
    return this.fSendNotificationCopy;
  }

  get serialNumber(): number | undefined {
    return this.fSerialNumber;
  }
}
